import { ReactElement } from 'react';
// eslint-disable-next-line import/no-named-as-default
import toast, { Toaster as RHTToaster, Toast, resolveValue } from 'react-hot-toast';

import Alert from './components/Alert';

export default function Toaster(): ReactElement {
  return (
    <RHTToaster
      position='top-center'
      toastOptions={{
        duration: 15000,
        error: {
          duration: 15000
        },
        success: {
          duration: 15000
        }
      }}>
      {(t: Toast) => (
        <Alert
          open={t.visible}
          severity={t.type === 'success' ? 'success' : t.type === 'error' ? 'error' : 'info'}
          onClose={() => toast.remove(t.id)}>
          {resolveValue(t.message, t)}
        </Alert>
      )}
    </RHTToaster>
  );
}
